module.exports = __webpack_public_path__ + "img/applicantdetail01.176f8eed.png";